module.exports = __webpack_public_path__ + "media/images/new_audience_guide-b80bd49c2f423ded9d2389aaddccbc3a.jpeg";